import React from "react";
import { Checkbox } from "@commonsku/design-system";

export interface TaskCheckboxProps {
  checked: boolean;
  onChange: (complete: boolean) => void;
  label: string;
}

const TaskCheckbox = ({ checked, onChange, label }: TaskCheckboxProps) => {
  return (
    <Checkbox.Root
      checked={checked}
      colorPalette="brand"
      size="sm"
      onCheckedChange={(details) => onChange(!!details.checked)}
      onClick={(e) => e.stopPropagation()}
      aria-label={label}
      flexShrink="0"
      marginTop="1"
    >
      <Checkbox.HiddenInput />
      <Checkbox.Control>
        <Checkbox.Indicator />
      </Checkbox.Control>
    </Checkbox.Root>
  );
};

export default TaskCheckbox;
